if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';

        const cartPayload = this.buildCartFormData();
        if (cartPayload.type === 'json') {
          config.headers['Content-Type'] = 'application/json';
          const payload = { ...cartPayload.body };
          if (this.cart) {
            payload.sections = this.cart.getSectionsToRender().map((section) => section.id);
            payload.sections_url = window.location.pathname;
            this.cart.setActiveElement(document.activeElement);
          }
          config.body = JSON.stringify(payload);
        } else {
          delete config.headers['Content-Type'];
          const formData = cartPayload.body;
          if (this.cart) {
            formData.append(
              'sections',
              this.cart.getSectionsToRender().map((section) => section.id)
            );
            formData.append('sections_url', window.location.pathname);
            this.cart.setActiveElement(document.activeElement);
          }
          config.body = formData;
        }

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: cartPayload.type === 'json'
                  ? cartPayload.body.items?.[0]?.id
                  : cartPayload.body.get('id') || cartPayload.body.get('items[0][id]'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: cartPayload.type === 'json'
                  ? cartPayload.body.items?.[0]?.id
                  : cartPayload.body.get('id') || cartPayload.body.get('items[0][id]'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
            
            const html = `
              <div class="footer__payment">
                <span class="visually-hidden">{{ 'sections.footer.payment' | t }}</span>
                <ul class="list list-payment" role="list">
                  {% assign enabled_payment_types = 'american_express,apple_pay,google_pay,klarna,maestro,master,paypal,shopify_pay,unionpay,visa,bancontact,eps,ideal'
                    | remove: ' '
                    | split: ','
                  %}
                  {%- for type in enabled_payment_types -%}
                    <li class="list-payment__item">
                      {{ type | payment_type_svg_tag: class: 'icon icon--full-color' }}
                    </li>
                  {%- endfor -%}
                </ul>
              </div>
            `;
            document.querySelector("#cart_footer_payment")?.insertAdjacentHTML("beforeend", html);
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      pricePlanSelector() {
        const sectionId = this.dataset.sectionId;
        if (sectionId) {
          const scoped =
            document.querySelector(`price-plan-selector[data-section="${sectionId}"]`) ||
            document.querySelector(`product-info [data-section="${sectionId}"]`);
          if (scoped?.matches?.('price-plan-selector')) return scoped;
          if (scoped) {
            const nested = scoped.querySelector('price-plan-selector');
            if (nested) return nested;
          }
        }
        return (
          document.querySelector('product-info price-plan-selector') ||
          document.querySelector('price-plan-selector')
        );
      }

      buildCartFormData() {
        const formData = new FormData(this.form);
        const selector = this.pricePlanSelector();

        if (selector?.buildCartItems) {
          const items = selector.buildCartItems();
          const forceJsonCart =
            items.length > 1 ||
            (selector.dataset?.kwfmFrauMannGifts === 'true' &&
              selector.getActiveMode?.() === 'sub' &&
              items.length > 0);

          if (forceJsonCart) {
            return { type: 'json', body: { items } };
          }

          if (items.length === 1) {
            const item = items[0];
            formData.delete('id');
            formData.delete('quantity');
            formData.delete('selling_plan');
            if (item.selling_plan) formData.append('selling_plan', String(item.selling_plan));
            formData.append('id', String(item.id));
            formData.append('quantity', String(item.quantity));
            return { type: 'form', body: formData };
          }
        }

        const extras = selector?.getAdditionalItems?.() || [];
        const main = selector?.getMainCartItem?.();
        const sparplanGroupId =
          selector?.getActiveMode?.() === 'sub' && extras.length > 0
            ? selector._pendingSparplanGroupId || selector.sparplanGroupId?.()
            : '';
        const mainSparplanProps = selector?.mainSparplanProperties?.(sparplanGroupId);

        const mainId = main?.id || formData.get('id');
        const quantity = main?.quantity || formData.get('quantity') || '1';
        const sellingPlan = main ? main.sellingPlan : formData.get('selling_plan');

        formData.delete('id');
        formData.delete('quantity');
        formData.delete('selling_plan');

        if (!extras.length && !main) {
          if (sellingPlan) formData.append('selling_plan', sellingPlan);
          formData.append('id', mainId);
          formData.append('quantity', quantity);
          return { type: 'form', body: formData };
        }

        const cartItems = [];
        if (mainId) {
          const mainLine = {
            id: parseInt(mainId, 10),
            quantity: parseInt(quantity, 10) || 1,
            selling_plan: sellingPlan ? parseInt(sellingPlan, 10) : undefined,
          };
          if (mainSparplanProps) mainLine.properties = mainSparplanProps;
          cartItems.push(mainLine);
        }
        extras.forEach((item) => {
          const lineItem = {
            id: parseInt(item.id, 10),
            quantity: parseInt(item.quantity, 10) || 1,
          };
          const planId = parseInt(item.sellingPlan, 10);
          if (planId > 0) {
            lineItem.selling_plan = planId;
          }
          if (item.properties) {
            lineItem.properties = item.properties;
          } else if (sparplanGroupId) {
            lineItem.properties = { _sparplan_group: sparplanGroupId };
          }
          cartItems.push(lineItem);
        });

        if (cartItems.length === 1) {
          const item = cartItems[0];
          if (item.selling_plan) formData.append('selling_plan', String(item.selling_plan));
          formData.append('id', String(item.id));
          formData.append('quantity', String(item.quantity));
          return { type: 'form', body: formData };
        }

        // Shopify cart drawer lists newest items first, so add in reverse:
        // main product last → appears at top, then Omega-3, then Vitamin D3.
        return { type: 'json', body: { items: cartItems.slice().reverse() } };
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}

//  sticky add to cart button
var stickyAddToCart = document.querySelector(
  ".main-product .sticky-add-to-cart__wrapper"
);
if (stickyAddToCart) {
  function addbuttonScroll() {
    const originalAddToCartBtn = document.querySelector(
      ".main-product .product-form"
    );
    const rect = originalAddToCartBtn.getBoundingClientRect();
    if (rect.bottom <= 0) {
      stickyAddToCart.classList.remove("sticky-add-to-cart--hidden");
    } else {
      stickyAddToCart.classList.add("sticky-add-to-cart--hidden");
    }
  }
  window.addEventListener("scroll", addbuttonScroll);
}


// document.addEventListener("DOMContentLoaded", function () {
//     const stickyCartWrapper = document.querySelector(".product-form__buttons .product-form__submit");
//     const addToCartButton = document.querySelector(".sticky-add-to-cart__wrapper"); // Change this selector as per your button class

//     function checkVisibility() {
//         if (stickyCartWrapper) {
//             const rect = stickyCartWrapper.getBoundingClientRect();
//             const isVisible = rect.top >= 0 && rect.bottom - 50 <= window.innerHeight;

//             if (!isVisible) {
//                 addToCartButton.classList.remove("sticky-add-to-cart--hidden");
//             } else {
//                 addToCartButton.classList.add("sticky-add-to-cart--hidden");
//             }
//         }
//     }

//     // Run on load and scroll
//     window.addEventListener("scroll", checkVisibility);
//     checkVisibility();
// });

// redirect to faq section
function scrollToFaq() {
    document.getElementById('faq-section').scrollIntoView({ behavior: 'smooth' });
}
